export const categories = [
  {
    slug: 'dianying',
    name: '电影',
    description: '正版免费电影在线观看，涵盖动作、喜剧、爱情、科幻、悬疑等多种类型，高清画质流畅播放。',
    icon: 'ri-movie-2-line',
    count: 126,
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    description: '海量正版电视剧免费追，国产剧、韩剧、美剧、日剧应有尽有，更新及时画质清晰。',
    icon: 'ri-tv-2-line',
    count: 89,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '精品纪录片免费看，自然、历史、科技、人文各类题材，开阔视野增长知识。',
    icon: 'ri-film-line',
    count: 64,
  },
  {
    slug: 'dongman',
    name: '动漫',
    description: '热门动漫番剧免费在线看，国漫日漫经典新番一网打尽，高清流畅不卡顿。',
    icon: 'ri-emotion-line',
    count: 98,
  },
  {
    slug: 'zongyi',
    name: '综艺',
    description: '热门综艺节目免费看，音乐、脱口秀、真人秀、竞技类节目精彩不断。',
    icon: 'ri-live-line',
    count: 55,
  },
];

export const platforms = [
  {
    id: 'p1',
    name: 'B站影视区',
    slug: 'bilibili-yingshi',
    category: 'dianying',
    categories: ['dianying', 'dianshiju', 'dongman', 'jilupian', 'zongyi'],
    description: 'B站影视区拥有海量正版影视资源，涵盖电影、番剧、纪录片等品类，依托强大的社区生态，用户可以在观看的同时参与弹幕互动，体验独特的观影乐趣。平台持续引进优质版权内容，大部分资源无需付费即可观看。',
    rating: 4.8,
    features: ['弹幕互动', '无广告', '高清画质', '多端同步', '社区评论'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20with%20warm%20coral%20accent%20colors%2C%20movie%20thumbnails%20grid%20layout%2C%20clean%20minimal%20UI%20design%2C%20soft%20ambient%20lighting%2C%20digital%20entertainment%20aesthetic%2C%20sleek%20card%20based%20design%2C%20warm%20neutral%20background&width=800&height=600&seq=platform-bilibili&orientation=landscape',
    url: '#',
    tags: ['弹幕', '社区', '番剧', '纪录片'],
    isFeatured: true,
  },
  {
    id: 'p2',
    name: '1905电影网',
    slug: '1905-dianyingwang',
    category: 'dianying',
    categories: ['dianying'],
    description: '1905电影网是国家电影局主管的正版电影平台，拥有海量经典国产电影资源，全部免费观看。平台电影库涵盖建国以来各个时期的优秀影片，是了解中国电影历史的绝佳窗口，画质清晰、播放流畅。',
    rating: 4.6,
    features: ['经典国产电影', '正版授权', '无广告', '高清修复', '分类详尽'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20cinema%20streaming%20platform%20interface%2C%20vintage%20movie%20posters%20gallery%2C%20warm%20golden%20tones%2C%20elegant%20typography%2C%20film%20reel%20aesthetic%2C%20cinematic%20lighting%2C%20clean%20modern%20layout&width=800&height=600&seq=platform-1905&orientation=landscape',
    url: '#',
    tags: ['国产电影', '经典', '正版'],
    isFeatured: true,
  },
  {
    id: 'p3',
    name: '西瓜视频',
    slug: 'xigua-shipin',
    category: 'dianshiju',
    categories: ['dianshiju', 'dianying', 'zongyi'],
    description: '西瓜视频聚合了大量正版影视内容，包括热门电视剧、电影和综艺节目。平台通过个性化推荐算法，为用户精准匹配感兴趣的影视内容，并提供高清流畅的播放体验，大部分内容可免费观看。',
    rating: 4.5,
    features: ['个性推荐', '海量片库', '高清播放', '离线缓存', '多端互通'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Video%20streaming%20app%20interface%20with%20personalized%20recommendation%20feed%2C%20colorful%20content%20thumbnails%2C%20warm%20living%20room%20scene%20with%20TV%20screen%2C%20cozy%20atmosphere%2C%20modern%20digital%20lifestyle&width=800&height=600&seq=platform-xigua&orientation=landscape',
    url: '#',
    tags: ['推荐算法', '电视剧', '综艺'],
    isFeatured: true,
  },
  {
    id: 'p4',
    name: 'CCTV节目官网',
    slug: 'cctv-jieMu',
    category: 'zongyi',
    categories: ['zongyi', 'dianshiju', 'jilupian', 'dianying'],
    description: '央视节目官网（央视网）提供央视各频道节目的免费在线观看服务，涵盖新闻、综艺、纪录片、电视剧等丰富内容。作为国家级媒体平台，内容质量有保障，全部免费，支持直播和回看功能。',
    rating: 4.7,
    features: ['直播回看', '正版内容', '全免费', '高清画质', '内容权威'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20broadcast%20media%20streaming%20platform%2C%20news%20and%20documentary%20content%20grid%2C%20clean%20authoritative%20design%2C%20warm%20studio%20lighting%20aesthetic%2C%20modern%20newsroom%20vibe&width=800&height=600&seq=platform-cctv&orientation=landscape',
    url: '#',
    tags: ['央视', '直播', '新闻', '纪录片'],
    isFeatured: true,
  },
  {
    id: 'p5',
    name: '芒果TV免费区',
    slug: 'mangguo-tv-free',
    category: 'zongyi',
    categories: ['zongyi', 'dianshiju'],
    description: '芒果TV免费区汇集了平台自制的热门综艺节目和精选电视剧内容，无需会员即可观看。湖南卫视王牌综艺节目均可在免费区找到，内容更新及时，是综艺爱好者的必备平台。',
    rating: 4.4,
    features: ['自制综艺', '独家内容', '更新快', '高清播放', '弹幕互动'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20streaming%20platform%20with%20vibrant%20colorful%20thumbnails%2C%20cheerful%20bright%20design%2C%20warm%20orange%20accents%2C%20modern%20OTT%20platform%20interface%2C%20lively%20atmosphere&width=800&height=600&seq=platform-mango&orientation=landscape',
    url: '#',
    tags: ['综艺', '自制', '湖南卫视'],
    isFeatured: false,
  },
  {
    id: 'p6',
    name: '优酷免费剧场',
    slug: 'youku-free',
    category: 'dianshiju',
    categories: ['dianshiju', 'dianying', 'dongman'],
    description: '优酷免费剧场为用户提供大量经典电视剧、电影和动漫内容，无需开通会员即可观看。平台拥有丰富的港剧和经典国产剧资源，是怀旧剧迷的理想选择，播放稳定画质有保障。',
    rating: 4.3,
    features: ['经典港剧', '海量片库', '稳定播放', '多端支持', '画质可选'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20drama%20series%20streaming%20library%20interface%2C%20retro%20Chinese%20TV%20show%20posters%2C%20warm%20nostalgic%20tones%2C%20clean%20grid%20layout%2C%20soft%20cinematic%20lighting%2C%20cozy%20viewing%20atmosphere&width=800&height=600&seq=platform-youku&orientation=landscape',
    url: '#',
    tags: ['港剧', '经典', '免费'],
    isFeatured: false,
  },
  {
    id: 'p7',
    name: '腾讯视频限免区',
    slug: 'tencent-free',
    category: 'dianying',
    categories: ['dianying', 'dianshiju', 'dongman'],
    description: '腾讯视频限免区定期推出免费观影活动，涵盖热门电影、精品剧集和动漫番剧。限免内容每周更新，用户可以在活动期间免费观看原本需要会员的内容，是省钱追剧的好选择。',
    rating: 4.5,
    features: ['限免活动', '热门大片', '4K画质', '杜比音效', '多端同步'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20video%20streaming%20platform%20with%204K%20movie%20showcase%2C%20high-end%20cinematic%20interface%2C%20warm%20dark%20theme%20with%20gold%20accents%2C%20luxurious%20home%20theater%20aesthetic&width=800&height=600&seq=platform-tencent&orientation=landscape',
    url: '#',
    tags: ['限免', '4K', '热门'],
    isFeatured: false,
  },
  {
    id: 'p8',
    name: '爱奇艺免费专区',
    slug: 'iqiyi-free',
    category: 'dongman',
    categories: ['dongman', 'dianshiju', 'dianying', 'zongyi'],
    description: '爱奇艺免费专区提供丰富的动漫、电视剧和综艺资源，用户无需登录即可直接观看。平台动漫频道尤其出色，引进了大量日本正版番剧和优质国漫作品，是动漫爱好者的天堂。',
    rating: 4.6,
    features: ['日漫正版', '国漫精品', '无需登录', '高清流畅', '更新同步'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20streaming%20platform%20with%20colorful%20animation%20thumbnails%2C%20manga-style%20illustration%20background%2C%20warm%20and%20vibrant%20color%20palette%2C%20Japanese%20anime%20aesthetic%2C%20clean%20card%20layout&width=800&height=600&seq=platform-iqiyi&orientation=landscape',
    url: '#',
    tags: ['动漫', '日漫', '国漫'],
    isFeatured: false,
  },
  {
    id: 'p9',
    name: '抖音影视号',
    slug: 'douyin-yingshi',
    category: 'dianying',
    categories: ['dianying', 'dianshiju', 'zongyi'],
    description: '抖音平台涌现了大量优质影视解说账号，通过短视频形式为观众推荐和解读电影电视剧。虽然以短视频为主，但许多账号提供了完整的观影指引和免费资源链接，是发现好片的新兴渠道。',
    rating: 4.2,
    features: ['短视频推荐', '影视解说', '发现好片', '互动社区', '免费资源'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Short%20video%20movie%20review%20platform%20interface%2C%20vertical%20video%20feed%20with%20film%20thumbnails%2C%20warm%20social%20media%20aesthetic%2C%20modern%20smartphone%20screen%20displaying%20entertainment%20content&width=800&height=600&seq=platform-douyin&orientation=landscape',
    url: '#',
    tags: ['短视频', '解说', '推荐'],
    isFeatured: false,
  },
  {
    id: 'p10',
    name: '哔哩哔哩纪录片',
    slug: 'bilibili-doc',
    category: 'jilupian',
    categories: ['jilupian'],
    description: 'B站纪录片频道是国内最大的正版纪录片免费观看平台之一，与BBC、Discovery、NHK等国际知名机构合作，引进大量优质纪录片。涵盖自然、历史、科技、美食等主题，所有内容均可免费观看。',
    rating: 4.7,
    features: ['BBC正版', 'Discovery合作', '4K画质', '双语字幕', '社区讨论'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Documentary%20streaming%20platform%20with%20nature%20and%20wildlife%20thumbnails%2C%20educational%20content%20grid%2C%20warm%20earth%20tones%2C%20cinematic%20documentary%20aesthetic%2C%20National%20Geographic%20style%20layout&width=800&height=600&seq=platform-doc&orientation=landscape',
    url: '#',
    tags: ['BBC', '纪录片', '4K', '自然'],
    isFeatured: true,
  },
];